import { render, staticRenderFns } from "./Packet.vue?vue&type=template&id=3ff02fd4"
import script from "./Packet.vue?vue&type=script&lang=js"
export * from "./Packet.vue?vue&type=script&lang=js"
import style0 from "./Packet.vue?vue&type=style&index=0&id=3ff02fd4&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports